export default "__VITE_ASSET__CVvE2QKM__"